import {ACCOUNT_ERROR, ACCOUNT_SUCCESS, ACCOUNT_REQUEST} from '../actions/account'
import {AUTH_LOGOUT} from '../actions/auth'
// import apiCall from '@/utils/api.js'
// import Vue from 'vue'

import { mock, accountData } from '../../utils/mockdata';
var axios = require('axios');


export default {

  state: {
    status: '',
    account: {},
  },
  
  getters: {
    getAccount: state => state.account,
    isAccountLoaded: state => !!state.account.id,
  },
  actions: {
    
    async fetchAccount({commit}, aid) {
      commit(ACCOUNT_REQUEST);

      await mock.onGet('/account', { params: { accountid: aid } }).reply(
        200, {data: accountData}
      );
        
      await axios.get('/account', { params: { accountid: aid } } )
      .then(resp => {
          commit(ACCOUNT_SUCCESS, resp.data.data)
          // commit('setAccount', resp.data.data),
          // console.log("account fetched. > "+JSON.stringify(resp.data.data))
      })
      .catch(resp => {
        console.log("failed>  "+resp)
          commit(ACCOUNT_ERROR);
          // if resp is unauthorized, logout, to
          dispatch(AUTH_LOGOUT)
      })  
    },

    // },
    saveAccount({commit}, account) {
      // commit('saveAccountProfile', accoutprofile)
      commit(ACCOUNT_SUCCESS, account)
    },

  },
  mutations: {
    [ACCOUNT_REQUEST]: (state) => {
      state.status = 'loading'
    },
    [ACCOUNT_SUCCESS]: (state, account) => {
      state.status = 'success';
      // Vue.set(state, 'profile', resp)
      state.account = account
    },
    [ACCOUNT_ERROR]: (state) => {
      state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
      state.profile = {}
    },
    saveAccountProfile: (state, accountprofile) => {
      state.profile = accountprofile
    }
  },
  

}

// == Default structure ==
// export default {
//   state: {},
//   getters: {},
//   actions: {},
//   mutations: {},
// }
